export default "/static/webpack/js/components/Organizations/Search/icon-plus.svg";